/* Publish by EComposer at 2026-10-02 09:19:09*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ejs6sozommv"]=  window.__ectimmers["ecom-ejs6sozommv"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ejs6sozommv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ejs6sozommv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-snhfu9n8yo9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-snhfu9n8yo9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hewyz7pwwr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hewyz7pwwr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j4u0rlxqh1q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j4u0rlxqh1q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k2fghxeh3bj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k2fghxeh3bj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sbvecrpxgr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sbvecrpxgr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q4q5nu6vsyh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q4q5nu6vsyh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kp9wxub4jzb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kp9wxub4jzb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4vnb3xof70o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4vnb3xof70o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vfpvy7dry1d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vfpvy7dry1d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-atsl4ylffmk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-atsl4ylffmk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cedaj0wov4n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cedaj0wov4n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j83p53hiyyr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j83p53hiyyr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1thboqjhzff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1thboqjhzff', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3vz86i9mql9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3vz86i9mql9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wwsix4jw9m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wwsix4jw9m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rhlmx56d42').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rhlmx56d42', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-axruuepxq9i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-axruuepxq9i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l6ybjik8v9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l6ybjik8v9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzm3kd5ece').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzm3kd5ece', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kw5tv1g6lnk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kw5tv1g6lnk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1bmu1g42zl6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1bmu1g42zl6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2j95mtmykjv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2j95mtmykjv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4uv36c7b22p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4uv36c7b22p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1enlylewc9w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1enlylewc9w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-30iyfy1vma5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-30iyfy1vma5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mtgupcmvs4m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mtgupcmvs4m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xgcs0lh0dfj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xgcs0lh0dfj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zbns1yerx4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zbns1yerx4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-parrlkh1jmq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-parrlkh1jmq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aqe513pia6j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aqe513pia6j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6qsfdow4r8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6qsfdow4r8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iyuns39qqi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iyuns39qqi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7xm4g9reozv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xm4g9reozv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6k1lgks7tnq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6k1lgks7tnq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y7ck1q58isb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y7ck1q58isb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwpy81fe7o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwpy81fe7o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-txyc5any81').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-txyc5any81', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nkea82ewlm9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nkea82ewlm9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-39cd0d8jgc1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-39cd0d8jgc1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ezgsf07vlju').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ezgsf07vlju', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3gechb9lysq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3gechb9lysq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wk4bczsxe2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wk4bczsxe2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7r8rnv5dv2j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7r8rnv5dv2j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vlb4278rb99').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vlb4278rb99', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1cmp0d468k8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1cmp0d468k8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oaxoumnwp2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oaxoumnwp2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3dabqeierki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3dabqeierki', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ru23kmmso').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ru23kmmso', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xjk38ku08so').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xjk38ku08so', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6xz46c67sv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6xz46c67sv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qd6obrlux7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qd6obrlux7a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1u8pp7odml8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1u8pp7odml8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o6tn2jnmx9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o6tn2jnmx9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q74o7gdk6fc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q74o7gdk6fc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o5vhq9y19z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o5vhq9y19z', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-biz2i6yvpyd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-biz2i6yvpyd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mj9jx2mn8hj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mj9jx2mn8hj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h34vckdh5zv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h34vckdh5zv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5jtv8zcmym8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5jtv8zcmym8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v66zch9hk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v66zch9hk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fad4tie0cxi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fad4tie0cxi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6bvwu348hns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6bvwu348hns', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8sacjf82geq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8sacjf82geq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-28w19cb8pun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-28w19cb8pun', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m7u0miztxxg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m7u0miztxxg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fol0gxhu1kj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fol0gxhu1kj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iuujt3sm0aa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iuujt3sm0aa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kqx1l89fczi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kqx1l89fczi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4bhumq9o9sv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4bhumq9o9sv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-klulfovr70s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-klulfovr70s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xor7ackdaxs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xor7ackdaxs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ii9hvmkqz4a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ii9hvmkqz4a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j4qaw300dne').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j4qaw300dne', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e8ja7sb7h1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e8ja7sb7h1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3lks2ny6w9z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3lks2ny6w9z', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yoovcbso8zd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yoovcbso8zd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1n2l1w92zjp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1n2l1w92zjp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-phd28ezykv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-phd28ezykv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-80n5rmtmsoj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-80n5rmtmsoj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8zgig8zi2in').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8zgig8zi2in', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kiovd7j71xt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kiovd7j71xt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2pp4rnfpsrg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2pp4rnfpsrg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7hs8bu6pwxr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7hs8bu6pwxr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-694ergf75b8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-694ergf75b8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k5dwjtuvrc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k5dwjtuvrc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8xs08r172bc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8xs08r172bc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bb2p77unv8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bb2p77unv8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ypzm5t1pv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ypzm5t1pv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ttv3f4518lr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ttv3f4518lr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w0keplbdx5c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w0keplbdx5c', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6kxdcu470lw"]=  window.__ectimmers["ecom-6kxdcu470lw"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-6kxdcu470lw"]["3r98mrci5"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-6kxdcu470lw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6kxdcu470lw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ivfgfcxymd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ivfgfcxymd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7b558dt13ab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7b558dt13ab', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iewr3ydmyv8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iewr3ydmyv8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o3s1i0mcoxs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o3s1i0mcoxs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mnhhdij17').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mnhhdij17', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0zpcfxrqnsf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0zpcfxrqnsf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-02w7s84e048').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-02w7s84e048', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ahr5gm5vll').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ahr5gm5vll', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2g4kb47uewi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2g4kb47uewi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g713611twdf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g713611twdf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zin682nya9c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zin682nya9c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yof4fqkietk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yof4fqkietk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nqn5jjozs1s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nqn5jjozs1s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hn73olwnhcf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hn73olwnhcf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-im9nc4o2xpo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-im9nc4o2xpo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xhjkzldh08').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xhjkzldh08', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ikn2r1zbhfg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ikn2r1zbhfg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ztfjxi8z3uh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ztfjxi8z3uh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x15vpesmvia').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x15vpesmvia', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qi8bbdrjy89').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qi8bbdrjy89', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8g7yyxec8k4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8g7yyxec8k4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nv1wvmc022q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nv1wvmc022q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wje8j0ao57p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wje8j0ao57p', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-agp0gqxc8s"]=  window.__ectimmers["ecom-agp0gqxc8s"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,o=($=this.settings.disable_auto_close__tablet)!=null?$:!1,n=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function f(L){return n&&L<768||o&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let X=null;function G(oe){X||(X=oe);const se=Math.min((oe-X)/Z,1),U=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*U),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,X=Z.querySelector(":scope > .ecom-accordion__body");!r&&X&&X.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");X&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{X.style.height=X.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),U=this.parentNode,de=U.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),ee=U.querySelector(":scope > .ecom-accordion__body");U.classList&&U.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=f(se);if(q)J?(this.classList.remove("ecom-item-active"),U.classList.remove("ecom-item-active"),y(U)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),U.classList.add("ecom-item-active");let fe=U.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&ee&&ee.classList.add("ecom-effect-accodion"),b(ee)}window.dispatchEvent(new window.Event("renderScroll"));const K=this,ue=s||se>1024;function Y(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(K)&&k(K)}if(ue&&!r){let fe;const Te=function(Ce){Ce.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},600)}else requestAnimationFrame(()=>{setTimeout(Y,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-agp0gqxc8s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-agp0gqxc8s', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-utg66uqwx7c"]=  window.__ectimmers["ecom-utg66uqwx7c"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-utg66uqwx7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-utg66uqwx7c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-84znet9uv34').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-84znet9uv34', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e7mvajp53ni').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e7mvajp53ni', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gmlrew3wael').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gmlrew3wael', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wa1e5o2w3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wa1e5o2w3c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-urkl0ax71ws').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-urkl0ax71ws', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4pd0c5ixifs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4pd0c5ixifs', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wk94em5th2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wk94em5th2', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m8y1c53cfor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m8y1c53cfor', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-glvmeh1hmum').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-glvmeh1hmum', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jsc1mqpxjo9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jsc1mqpxjo9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h6oetel09xp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h6oetel09xp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k25txw1affk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k25txw1affk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2illiuxab2p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2illiuxab2p', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6scjhcs2o3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6scjhcs2o3l', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7zt4vn3y01m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7zt4vn3y01m', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-igrlcyuvewb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-igrlcyuvewb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kyhq01pp78').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kyhq01pp78', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3g4s1dgdfea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3g4s1dgdfea', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a6jlokft4ze').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a6jlokft4ze', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-une3931b4to').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-une3931b4to', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uaxvmczlj9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uaxvmczlj9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u003hqx5vw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u003hqx5vw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7aom4uu9o1m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7aom4uu9o1m', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e93bj51w7la').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e93bj51w7la', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9c9zvlt6jxk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9c9zvlt6jxk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}